import { Component } from '@angular/core';
import { AdminModule } from '../admin.module';

@Component({
  selector: 'app-tasks-complete-page',
  standalone: true,
  imports: [AdminModule],
  templateUrl: './tasks-complete-page.component.html',
  styleUrl: './tasks-complete-page.component.css'
})
export class TasksCompletePageComponent {

}
